import { useContext } from "react";
import { OrganizationContext } from "./OrganizationContext";

export function useOrganizationContext() {
  const organization = useContext(OrganizationContext);
  if (!organization) {
    throw new Error(
      "useOrganizationContext must be used within an OrganizationProvider",
    );
  }
  return organization;
}
